import { validateRule } from '@inixiative/json-rules';
import { foldConditionTree, type RelationArms } from './foldConditionTree';

// gloss
export const hasLeaf = (node: unknown): boolean =>
  foldConditionTree<boolean>(node, {
    literal: (value) => typeof value === 'boolean',
    group: (children) => children.some(Boolean),
    ifThenElse: (branches) => branches.if || branches.then || Boolean(branches.else),
    relation: ({ node: relation }) => 'field' in relation,
    leaf: ({ node: leaf }) => 'field' in leaf,
  });

// gloss
export const isIncompleteValue = (value: unknown): boolean => {
  if (value === '') return true;
  if (Array.isArray(value)) return value.length === 0 || value.some((bound) => bound === '' || bound == null);
  return false;
};

const hasEmptyValue = (node: unknown): boolean =>
  foldConditionTree<boolean>(node, {
    literal: () => false,
    group: (children) => children.some(Boolean),
    ifThenElse: (branches) => branches.if || branches.then || Boolean(branches.else),
    relation: ({ foldInner }) => foldInner(),
    leaf: ({ node: leaf }) => isIncompleteValue(leaf.value),
  });

// gloss
export const hasConditionRule = (condition: unknown): boolean =>
  hasLeaf(condition) && validateRule(condition).ok && !hasEmptyValue(condition);

const readsMembership = (field: unknown): boolean =>
  typeof field === 'string' && (field === 'fanUserGroups' || field.startsWith('fanUserGroups.'));

// gloss
export const hasSegmentMembershipRule = (node: unknown): boolean => {
  const relation = ({ node: rule, foldInner, foldFilter }: RelationArms<boolean>): boolean =>
    readsMembership(rule.field) || foldInner() || foldFilter();
  return foldConditionTree<boolean>(node, {
    literal: () => false,
    group: (children) => children.some(Boolean),
    ifThenElse: (branches) => branches.if || branches.then || Boolean(branches.else),
    relation,
    aggregate: relation,
    leaf: ({ node: leaf }) => readsMembership(leaf.field),
  });
};
